import { getElementById } from "../util/Utils";
import { filter, filterFooter, filterTitle, nextBestActionButtons } from "./Selectors";
import {
  enterSecondLevelFilter,
  exitSecondLevelFilter,
  toggleFilterAccordion,
} from "@otto-ec/heureka-components/filter";
import { resetFacetLocation, setFacetLocation } from "@otto-ec/heureka-components/facet";
import { fireFilterSubmit } from "../filter/FilterFormActions";
import { Filter } from "../filter/Filter";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

const FILTER_SHEET_ID = "heureka-filtersheet";
const SHEET_HEADLINE_PLACEHOLDER_ID = "heureka-filtersheet-headline-placeholder";
const SHEET_HEADLINE_SELECTOR = ".heureka_filterSheet__headline";
const SHEET_HEADLINE_CONTENT_SELECTOR = ".heureka_filterSheet__headlineContent";
const SHEET_CONTENT_SELECTOR = ".heureka_filterSheet__content";
const SHEET_ACTIONS_SELECTOR = ".heureka_filterSheet__actions";
const DENSE_LIST_ID = "heureka_filterTitlesDense";
/*                                                                                             */
const LIFTED_ROW_PLACEHOLDER_CLASS = "heureka_filterSheet__liftedRowPlaceholder";

/*                                                                                            */
export const LEVEL_SECOND_CLASS = "heureka_filterSheet--level-second";
/*                                                                           */
export const LEVEL_SECOND_NBF_CLASS = "heureka_filterSheet--level-second-nbf";
/*                                                                           */
export const ACTIVE_FILTER_CLASS = "heureka_filterTitle--activeInSheet";

/**
 *
 *
 */
let secondLevelSubmitted = false;

/*                                                                                         */
function onSecondLevelFilterSubmit(): void {
  secondLevelSubmitted = true;
}
/*                                                                                         */
const SECOND_LEVEL_ACTIONS_CLASS = "heureka_filterSheet__secondLevelActions";

function sheet(): HTMLElement | null {
  return getElementById(FILTER_SHEET_ID);
}

function sheetContent(): HTMLElement | null {
  return sheet()?.querySelector<HTMLElement>(SHEET_CONTENT_SELECTOR) ?? null;
}

function sheetActions(): HTMLElement | null {
  return sheet()?.querySelector<HTMLElement>(SHEET_ACTIONS_SELECTOR) ?? null;
}

/**
 *
 *
 *
 */
function ensureActiveFacetGroup(filterId: string): void {
  const groups = Filter.filterId(filterId)?.facetGroups ?? [];
  if (groups.length === 0) return; /*                             */
  if (groups.some((group) => group.active)) return; /*                          */
  const firstVisible = groups.find((group) => !group.facetGroup.hidden) ?? groups[0];
  firstVisible.toggleVisibility(true);
}

/**
 *
 *
 *
 *
 */
function liftActiveRowFromExpander(filterId: string): void {
  const titleElem = filterTitle(filterId);
  const row = titleElem?.closest("oc-row-v2");
  const expander = row?.closest("oc-expander-v1");
  if (!row || !expander) return; /*                  */

  const denseList = getElementById(DENSE_LIST_ID);
  if (!denseList) return;

  const placeholder = document.createElement("div");
  placeholder.className = LIFTED_ROW_PLACEHOLDER_CLASS;
  placeholder.hidden = true;
  row.replaceWith(placeholder);
  denseList.appendChild(row);
}

/*                                                                                      */
function restoreLiftedRow(): void {
  const content = sheetContent();
  const placeholder = content?.querySelector<HTMLElement>(`.${LIFTED_ROW_PLACEHOLDER_CLASS}`);
  const denseList = getElementById(DENSE_LIST_ID);
  const liftedRow = denseList?.querySelector<HTMLElement>(`oc-row-v2:has(.${ACTIVE_FILTER_CLASS})`);
  if (placeholder && liftedRow) {
    placeholder.replaceWith(liftedRow);
  } else {
    placeholder?.remove();
  }
}

/**
 *
 *
 */
function applyActiveRowSpacing(filterId: string): void {
  const row = filterTitle(filterId)?.closest<HTMLElement>("oc-row-v2");
  if (!row) return;
  row.dataset.originalSpacingY = row.style.getPropertyValue("--custom-spacing-y");
  row.dataset.originalHideDivider = row.hasAttribute("hide-divider") ? "true" : "false";
  row.style.setProperty("--custom-spacing-y", "var(--oc-semantic-spacing-0)");
  row.setAttribute("hide-divider", "");
}

/*                                                                                                            */
function restoreActiveRowSpacing(): void {
  const content = sheetContent();
  const row = content?.querySelector<HTMLElement>(`oc-row-v2:has(.${ACTIVE_FILTER_CLASS})`);
  if (!row) return;
  const { originalSpacingY, originalHideDivider } = row.dataset;
  if (originalSpacingY) {
    row.style.setProperty("--custom-spacing-y", originalSpacingY);
  } else {
    row.style.removeProperty("--custom-spacing-y");
  }
  if (originalHideDivider === "false") {
    row.removeAttribute("hide-divider");
  }
  delete row.dataset.originalSpacingY;
  delete row.dataset.originalHideDivider;
}

/*                                                                                */
export function isSecondLevelActive(): boolean {
  return !!sheet()?.classList.contains(LEVEL_SECOND_CLASS);
}

/*                                                                                 */
export function isSecondLevelNbf(): boolean {
  return !!sheet()?.classList.contains(LEVEL_SECOND_NBF_CLASS);
}

function addSecondLevelHeadline(filterId: string, sheetElement: HTMLElement) {
  const title = filterTitle(filterId)?.dataset.filterTitle;
  const headline = getElementById(SHEET_HEADLINE_PLACEHOLDER_ID)?.querySelector(SHEET_HEADLINE_SELECTOR);
  const headlineContent = headline?.querySelector(SHEET_HEADLINE_CONTENT_SELECTOR);
  if (title && headline) {
    headlineContent.textContent = title;
    sheetElement.appendChild(headline);
  }
}

/**
 *
 *
 *
 *
 */
export function enterSecondLevel(filterId: string, nbf: boolean): void {
  const sheetElement = sheet();
  if (!sheetElement) return;

  /*                                                                                               */
  /*                                                   */
  enterSecondLevelFilter(filterId);
  toggleFilterAccordion(filterId, true);
  setFacetLocation(nbf ? "nbf_sheet" : "second_level", filterId);

  /*                                                                                                 */
  secondLevelSubmitted = false;
  sheetElement.addEventListener("filterSubmit", onSecondLevelFilterSubmit, { capture: true });

  const content = sheetContent();
  if (content) {
    content.dataset.activeFilterId = filterId;
  }

  sheetElement.classList.add(LEVEL_SECOND_CLASS);
  sheetElement.classList.toggle(LEVEL_SECOND_NBF_CLASS, nbf);
  if (nbf) {
    sheetElement.removeAttribute("full-height");
  }

  /*                                                                                      */
  addSecondLevelHeadline(filterId, sheetElement);

  /*                                                                                            */
  /*                                        */

  /*                                                                                               */
  filterTitle(filterId)?.classList.add(ACTIVE_FILTER_CLASS);

  /*                                                                                           */
  /*                                                                                                 */
  /*                                                                       */
  liftActiveRowFromExpander(filterId);

  /*                                                                                                 */
  /*                                   */
  applyActiveRowSpacing(filterId);

  /*                                                                                                 */
  /*                                                                                                    */
  ensureActiveFacetGroup(filterId);

  /*                                                                                                 */
  /*                                                                                                 */
  /*                                                                                                    */
  const form = filter(filterId);
  const actions = sheetActions();
  if (form && actions) {
    const footerSource = nbf ? nextBestActionButtons(form) : filterFooter(form);
    if (footerSource) {
      Array.from(footerSource.children).forEach((child) => {
        child.classList.add(SECOND_LEVEL_ACTIONS_CLASS);
        actions.appendChild(child);
      });
    }
  }
}

function removeSecondLevelHeadline(sheetElement: HTMLElement) {
  const headline = sheetElement.querySelector(SHEET_HEADLINE_SELECTOR);
  getElementById(SHEET_HEADLINE_PLACEHOLDER_ID)?.appendChild(headline);
}

/**
 *
 *
 */
export function exitSecondLevel(): void {
  const sheetElement = sheet();
  if (!sheetElement) return;

  const content = sheetContent();
  const filterId = content?.dataset.activeFilterId;
  const actions = sheetActions();
  const wasNbf = isSecondLevelNbf();

  sheetElement.removeEventListener("filterSubmit", onSecondLevelFilterSubmit, { capture: true });

  /*                                                                                                 */
  /*                                                                                              */
  /*                                                                                                  */
  /*                                                                                             */
  if (filterId && !secondLevelSubmitted) {
    const form = filter(filterId);
    if (form instanceof HTMLFormElement) {
      form.dataset.tsFeatureFilterMethod = "adopt";
      fireFilterSubmit(form);
    }
  }
  secondLevelSubmitted = false;

  /*                                                                                        */
  if (filterId && actions) {
    const form = filter(filterId);
    const footerTarget = form && (wasNbf ? nextBestActionButtons(form) : filterFooter(form));
    if (footerTarget) {
      actions.querySelectorAll<HTMLElement>(`.${SECOND_LEVEL_ACTIONS_CLASS}`).forEach((button) => {
        button.classList.remove(SECOND_LEVEL_ACTIONS_CLASS);
        footerTarget.appendChild(button);
      });
    }
  }

  sheetElement.classList.remove(LEVEL_SECOND_CLASS, LEVEL_SECOND_NBF_CLASS);
  if (wasNbf) {
    sheetElement.setAttribute("full-height", "");
  }
  if (content) {
    delete content.dataset.activeFilterId;
  }

  /*                               */
  removeSecondLevelHeadline(sheetElement);

  /*                                                                                                 */
  /*                                                 */
  restoreActiveRowSpacing();
  restoreLiftedRow();

  /*                             */
  if (filterId) {
    filterTitle(filterId)?.classList.remove(ACTIVE_FILTER_CLASS);
  }

  exitSecondLevelFilter();
  resetFacetLocation();
}
